module.exports = __webpack_public_path__ + "media/customizations/caldwellcommunities/logo-d0218838bbf81d21ed656743605c8e5a.png";